import React from 'react';
import { Link } from 'react-router-dom';
import { Swords, Heart } from 'lucide-react';

const Footer = () => {
  // Importer le store d'authentification
  const { user, isAuthenticated, logout } = require('../stores/authStore').useAuthStore();
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <Swords className="w-5 h-5 text-white" />
              </div>
              <span className="text-base sm:text-lg md:text-xl font-bold">KokBatay</span>
            </div>
            <p className="hidden sm:block text-xs sm:text-sm md:text-base text-gray-300 mb-4 max-w-md">
              La plateforme de paris moderne pour les combats de coqs en Haïti. 
              Parier en toute sécurité avec MonCash.
            </p>
            <div className="flex space-x-4">
            </div>
          </div>

          {/* Liens rapides et Support côte à côte en mobile */}
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h3 className="text-[0.6rem] sm:text-xs md:text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
                Navigation
              </h3>
              <ul className="space-y-3">
                {/* Accueil visible seulement pour admin */}
                {user && user.role === 'admin' && (
                  <li>
                    <Link to="/" className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors">
                      Accueil
                    </Link>
                  </li>
                )}
                {isAuthenticated ? (
                  <li>
                    <button
                      onClick={logout}
                      className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors bg-transparent border-none cursor-pointer"
                    >
                      Déconnexion
                    </button>
                  </li>
                ) : (
                  <>
                    <li>
                      <Link to="/login" className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors">
                        Connexion
                      </Link>
                    </li>
                    <li>
                      <Link to="/register" className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors">
                        Inscription
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </div>

            <div>
              <h3 className="text-[0.6rem] sm:text-xs md:text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
                Support
              </h3>
              <ul className="space-y-3">
                <li>
                  {/* <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    Centre d'aide
                  </a> */}
                  <Link to="/help" className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors">
                    Centre d'aide
                  </Link>
                </li>
                <li>
                  {/* <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    Contact
                  </a> */}
                  <Link to="/contact" className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors">
                    Contact
                  </Link>
                </li>
                <li>
                  {/* <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    Conditions d'utilisation
                  </a> */}
                  <Link to="/conditions-utilisation" className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors">
                    Conditions d'utilisation
                  </Link>
                </li>
                <li>
                  {/* <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    Politique de confidentialité
                  </a> */}
                  <Link to="/politique-confidentialite" className="text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-colors">
                    Politique de confidentialité
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-[0.55rem] sm:text-xs md:text-sm">
              © 2024 KokBatay. Tous droits réservés.
            </p>
            <p className="text-gray-400 text-[0.55rem] sm:text-xs md:text-sm mt-2 md:mt-0 flex items-center">
              Fait avec <Heart className="w-4 h-4 mx-1 text-red-500" /> en Haïti
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 